import { admin2 } from '@/api/instance'

// 查詢會員北捷任務狀況
export const GetMemberTaipeiMetroMissionStatus = async ({ shopId, phone }) => {
  return await admin2({
    method: 'get',
    url: `/${shopId}/taipeiMetro/getMissionStatus`,
    params: { phone },
  })
}

// 刷新會員餘額
export const RefreshMemberTaipeiMetroBalance = async ({ shopId, memberId }) => {
  const [data, errMsg, rawErr] = await admin2({
    method: 'post',
    url: `/${shopId}/taipeiMetro/refreshBalance`,
    data: { memberId },
  })

  // 如果已經是錯誤狀態，直接回傳
  if (rawErr) {
    return [data, errMsg, rawErr]
  }

  // 檢查業務邏輯錯誤：HTTP 200 但 success: false
  if (data?.success === false) {
    const errorMessage = data.errorCode === 'TAIPEI_METRO_RATE_LIMIT'
      ? '請稍後再試'
      : data.message || '餘額更新失敗'

    return [null, errorMessage, {
      isBusinessError: true,
      errorCode: data.errorCode,
      apiResponse: data,
    }]
  }

  return [data, errMsg, rawErr]
}

/**
 * 查詢北捷點數活動餘額 admin2.taipeiMetro.getPointStatus
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 店家 ID
 * @returns {Promise<[data, errMsg, rawErr]>} 回傳 [資料, 錯誤訊息, 原始錯誤]
 * @example
 * // 成功回傳格式
 * {
 *   remainingBalance: 1000,
 *   issuedAmount: 5000,
 *   recycledAmount: 4000
 * }
 */
export const GetTaipeiMetroPointStatus = async ({ shopId }) => {
  return await admin2({
    method: 'get',
    url: `/${shopId}/taipeiMetro/pointStatus`,
  })
}
